import {
  MinuteLyTopPostContainer,
  MinuteLyTopPosts,
  MinuteLyTopPostTextWrap,
  MinuteLyTopPostThumb,
  MinuteLyTopPostTitle,
  MinuteLyTopPostTopTitle,
  MinuteLyTopVideoContainer,
  MinuteLyTopVideoSlot,
  MinuteLyTopVideoSlotWrapper,
  MinuteLyTopVideoTitle,
  MinuteLyTopVideoTitleWrapper,
} from './MinuteLyTopVideo.style'
import { IMinuteLyTopVideoBlock, ITopVideoPost } from '../../../types'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import Link from '../../Link/Link'
import { RainbowUnderLine } from '../../RainbowUnderLine'

interface MinuteLyTopVideoProps {
  data: IMinuteLyTopVideoBlock
}

const MinuteLyTopPost = ({ data }: { data: ITopVideoPost }) => {
  const TopTitle = useMemo(() => {
    if (data.topTitle) {
      return (
        <MinuteLyTopPostTopTitle>
          {data.topTitle.split(' ').slice(0, 3).join(' ')}
        </MinuteLyTopPostTopTitle>
      )
    }
    return null
  }, [data.topTitle])

  const { desktopImage, mobileImage } = useMemo(() => {
    return {
      desktopImage: data.imageObj.d, //.replace('t_grid-item-large/', '')
      mobileImage: data.imageObj.m.replace(
        /t_grid-item-large|t_new_grid_item/,
        't_minute-ly-mobile'
      ),
    }
  }, [data.imageObj.d, data.imageObj.m])

  return (
    <MinuteLyTopPostContainer>
      <Link href={data.link}>
        <MinuteLyTopPostThumb>
          <img src={desktopImage} alt='' className={'desktop'} />
          <img src={mobileImage} alt='' className={'mobile'} />
        </MinuteLyTopPostThumb>
        <MinuteLyTopPostTextWrap>
          {TopTitle}
          <MinuteLyTopPostTitle>{data.title}</MinuteLyTopPostTitle>
        </MinuteLyTopPostTextWrap>
      </Link>
    </MinuteLyTopPostContainer>
  )
}

export const MinuteLyTopVideo = ({ data }: MinuteLyTopVideoProps) => {
  const { asPath } = useRouter()
  const slot = useMemo(() => {
    if (data.slotName && data.slotName !== 'auto') {
      return data.slotName
    }
    if (asPath === '/news/') {
      return 'news'
    }
    if (
      asPath.includes('allshows/series/57') ||
      asPath.includes('entertainment/the-big-brother')
    ) {
      return 'bb'
    }
    if (asPath === '/allshows/') {
      return 'ottweb'
    }
    return 'homepage'
  }, [asPath, data.slotName])

  return (
    <MinuteLyTopVideoContainer>
      <MinuteLyTopVideoSlotWrapper>
        <MinuteLyTopVideoTitleWrapper>
          <MinuteLyTopVideoTitle>{data.main_title}</MinuteLyTopVideoTitle>
          <RainbowUnderLine elementWidth={25} elementLeft={14} />
        </MinuteLyTopVideoTitleWrapper>
        <MinuteLyTopVideoSlot
          className={'mintelytopvideo-slot'}
          data-slot-name={slot}
        />
      </MinuteLyTopVideoSlotWrapper>
      <MinuteLyTopPosts>
        <MinuteLyTopVideoTitleWrapper>
          <MinuteLyTopVideoTitle>{data.secondary_title}</MinuteLyTopVideoTitle>
          <RainbowUnderLine elementWidth={25} elementLeft={14} />
        </MinuteLyTopVideoTitleWrapper>
        {data.posts.map(post => (
          <MinuteLyTopPost data={post} key={post.id} />
        ))}
      </MinuteLyTopPosts>
    </MinuteLyTopVideoContainer>
  )
}
